export const GET_TRANSACTION_PRICING_SUMMARY = gql`
    query getTransactionPricingOffers {
        getTransactionPricingOffers {
            id
            offerId
            offerName
            partnerName
            idPrefix
            assignToTotal
            status
            partners {
                id
                firstName
                lastName
                business {
                    legalName
                }
            }
            partnersOfPartner {
                id
                partnerId
                firstName
                lastName
                business {
                    legalName
                }
            }
        }
    }
`;
